/**
 * Stub for the retired NestJS araf-factory generated client.
 * These endpoints were generated by orval from the NestJS OpenAPI spec.
 * go-code-factory (Go BFF) does not implement these routes yet.
 * Functions throw at runtime so broken features fail loudly, not silently.
 */

const notImplemented = (name: string): never => {
  throw new Error(
    `${name}: NestJS araf-factory is retired — this endpoint is not yet available in go-code-factory`,
  );
};

// ─── Types ────────────────────────────────────────────────────────────────────

export interface WorkflowsUpdateBody {
  [key: string]: unknown;
}

// ─── Agents (NestJS) ─────────────────────────────────────────────────────────

// biome-ignore lint/suspicious/useAwait: stub
export const agentsDashboard = async (): Promise<never> => notImplemented('agentsDashboard');
// biome-ignore lint/suspicious/useAwait: stub
export const agentsDashboardOne = async (_name: string): Promise<never> =>
  notImplemented('agentsDashboardOne');

// ─── Workflows ────────────────────────────────────────────────────────────────

// biome-ignore lint/suspicious/useAwait: stub
export const workflowsGetRuns = async (_name?: string): Promise<never> =>
  notImplemented('workflowsGetRuns');
// biome-ignore lint/suspicious/useAwait: stub
export const workflowsGetStatus = async (_name?: string): Promise<never> =>
  notImplemented('workflowsGetStatus');
// biome-ignore lint/suspicious/useAwait: stub
export const workflowsList = async (): Promise<never> => notImplemented('workflowsList');
// biome-ignore lint/suspicious/useAwait: stub
export const workflowsGetItems = async (_name?: string): Promise<never> =>
  notImplemented('workflowsGetItems');
// biome-ignore lint/suspicious/useAwait: stub
export const workflowsGetOne = async (_name: string, _id: string): Promise<never> =>
  notImplemented('workflowsGetOne');
// biome-ignore lint/suspicious/useAwait: stub
export const workflowsTrigger = async (_name: string): Promise<never> =>
  notImplemented('workflowsTrigger');
// biome-ignore lint/suspicious/useAwait: stub
export const workflowsUpdate = async (_name: string, _id: string, _body: WorkflowsUpdateBody): Promise<never> =>
  notImplemented('workflowsUpdate');

// ─── Notifications ────────────────────────────────────────────────────────────

// biome-ignore lint/suspicious/useAwait: stub
export const listNotifications = async (): Promise<never> => notImplemented('listNotifications');
// biome-ignore lint/suspicious/useAwait: stub
export const clearAll = async (): Promise<never> => notImplemented('clearAll');
// biome-ignore lint/suspicious/useAwait: stub
export const dismissOne = async (_id: string): Promise<never> => notImplemented('dismissOne');
// biome-ignore lint/suspicious/useAwait: stub
export const markRead = async (_id: string): Promise<never> => notImplemented('markRead');
// biome-ignore lint/suspicious/useAwait: stub
export const markActioned = async (_id: string): Promise<never> => notImplemented('markActioned');

// ─── Review / ADO ─────────────────────────────────────────────────────────────

// biome-ignore lint/suspicious/useAwait: stub
export const listIntake = async (): Promise<never> => notImplemented('listIntake');
// biome-ignore lint/suspicious/useAwait: stub
export const getReviewDetail = async (_id: string): Promise<never> =>
  notImplemented('getReviewDetail');
// biome-ignore lint/suspicious/useAwait: stub
export const approveWorkItem = async (_id: string): Promise<never> =>
  notImplemented('approveWorkItem');
// biome-ignore lint/suspicious/useAwait: stub
export const requestChanges = async (_id: string, _comment: string): Promise<never> =>
  notImplemented('requestChanges');
// biome-ignore lint/suspicious/useAwait: stub
export const addComment = async (_id: string, _comment: string): Promise<never> =>
  notImplemented('addComment');
// biome-ignore lint/suspicious/useAwait: stub
export const fetchAdoFile = async (_url: string): Promise<never> => notImplemented('fetchAdoFile');
